import React from 'react';
import styled from 'styled-components';

// components
import AdjustmentButtons from './AdjustmentButtons';
import FullScreenButton from '../../../components/General/FullScreenButton';

type propTypes = {
  resetPosition: Function,
};

const Header = ({ resetPosition }: propTypes) => {
  return (
    <Styles>
      <AdjustmentButtons resetPosition={resetPosition} />

      <FullScreenButton componentName="canvas" />
    </Styles>
  );
};

export default Header;

const Styles: any = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 30px;
`;
